<template>
    <div>
      <!-- NAVBAR -->
      <my-navbar :controller="controller" />

      <!-- HEADER -->
      <div class="header bg-gradient-dark pb-8 pt-5 pt-md-8">
        <div class="container-fluid">
          <div class="header-body">
            <div class="row">
              <!-- CONTENIDO HEADER -->
            </div>
          </div>
        </div>
      </div>

      <!-- CONTENT -->
      <div class="container-fluid mt--7">
        <div class="row">
          <div class="col">
            <!-- COMPONENTE PRINCIPAL -->
            <div class="row">
              <div class="col-lg-6">
                <tiposComponent />
              </div>
              <div class="col-lg-6">
                <comparacionComponent />
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
</template>

<script>

  import tiposComponent from "@/components/baneados/tipos";
  import comparacionComponent from "@/components/baneados/comparacion";

  export default {
    name: "home",
    components: {
      tiposComponent,
      comparacionComponent
    },
    data() {
      return {
        controller: {
          title: "Opciones",
          mainRouter: "opciones"      
        }
      };
    }
  };
</script>